import { Component, Input, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild, ViewEncapsulation, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'gf-date-picker',
    template: `
    <div class="input-group date-field">
        <input
            class="form-control"
            maxlength="20"
            type="text"
            [placeholder]="placeholder"
            [value]="dateString"
            ngbDatepicker
            #d1="ngbDatepicker"
            (click)="onInputClick(d1)"
            (input)="onInputChange($event)"
            (blur)="onInputBlur($event)"
            (dateSelect)="onDateSelect($event)"
            [disabled]="!allowUpdate"
            #inputField
        >
        <span class="input-group-addon">
            <i class="glyphicon glyphicon-calendar" (click)="onCalendarIconClick(d1, $event)"></i>
        </span>
    </div>`,
    encapsulation: ViewEncapsulation.None
})
export class DatePickerComponent implements OnChanges {
    @ViewChild('d1', { static: false }) dp!: NgbInputDatepicker;
    @ViewChild('inputField', { static: false }) inputField!: ElementRef;
    @Input() date: string;
    @Input() useUtc: any;
    @Input() id: string;
    @Input() allowUpdate: boolean;
    @Input() options: any;
    @Input() placeholder: string = "";

    @Output() onUpdate: EventEmitter<string> = new EventEmitter<string>(); // Emit changes

    dateString: string = '';
    momentDate: moment.Moment;
    dateFormat: string;
    allowFreeText: boolean;
    isDate: boolean;
    format = 'L';
    isInternalChange = false;

    constructor(private renderer: Renderer2, private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.allowUpdate = _.isEmpty(this.allowUpdate) ? true : this.allowUpdate;
        this.setDateFromString(this.date);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.date && changes.date.currentValue) {
            if (this.isInternalChange) {
                this.isInternalChange = false;
                return;
            }
            let newValue = _.has(changes.date, 'currentValue.value') ? changes.date.currentValue.value : changes.date.currentValue;
            if (newValue != this.dateString) {
                this.setDateFromString(newValue);
            }
        }
    }

    setDateFromString(dateString: any): void {
        if (_.isEmpty(dateString)) return;

        // Ensure dateString is a string
        if (typeof dateString !== 'string') {
            dateString = dateString.toString();
        }

        let _momentDate: moment.Moment = null;
        this.momentDate = null;

        this.allowFreeText = _.get(this.options, 'allowFreeText', false);

        if (!(dateString.trim().startsWith('-') || dateString.trim().startsWith('+'))) {
            this.isDate = true;
            _momentDate = moment(dateString);

            if (this.useUtc) {
                _momentDate.utcOffset(0);
            }

            this.momentDate = _momentDate.isValid() ? _momentDate : null;
            this.dateFormat = _.get(this.options, 'dateFormat', 'YYYY-MM-DD');
            this.dateString = this.momentDate !== null
                ? this.momentDate.format(this.dateFormat)
                : this.allowFreeText
                    ? dateString
                    : '';

            this.cdr.detectChanges(); // Force change detection
        } else {
            this.isDate = false;
            this.dateString = this.allowFreeText ? dateString : '';
            this.cdr.detectChanges(); // Force change detection
        }
    }

    private ngbDateToString(dateStruct: NgbDateStruct): string {
        if (dateStruct) {
            // Ensure that the month and day have leading zeros
            const month = dateStruct.month.toString().padStart(2, '0');
            const day = dateStruct.day.toString().padStart(2, '0');
            const year = dateStruct.year.toString();

            return `${year}-${month}-${day}`;
        }

        return ''; // Return an empty string for null or undefined input
    }

    onDateSelect(event: any) {
        const selectedDate: NgbDateStruct = event;
        let date = this.ngbDateToString(selectedDate);

        this.isInternalChange = true;
        this.onUpdate.emit(date); // Emit the date change
        this.dateString = date;
    }

    onInputBlur(event: any) {
        let date = event.target.value;
        if (_.isObject(date)) {
            return;
        }

        // Only emit if the value has changed
        if (date !== this.dateString) {
            this.isInternalChange = true;
            this.onUpdate.emit(date); // Emit the date change on blur
        }
    }

        onInputChange(event: any) {
        this.dp.close();
    }



    onInputClick(datepicker: NgbInputDatepicker) {
        datepicker.toggle();
        setTimeout(() => {
            this.renderer.selectRootElement(this.inputField.nativeElement).focus();
        }, 0);
    }

    onCalendarIconClick(datepicker: NgbInputDatepicker, event: Event) {
        event.stopPropagation(); // Prevent the input click event from triggering
        datepicker.toggle();
        setTimeout(() => {
            this.renderer.selectRootElement(this.inputField.nativeElement).focus();
        }, 0);
    }
}
